import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./components/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import UserManagement from "./pages/user/UserManagement";
import SourceBusiness from "./pages/sourceBusiness/SourceBusiness";

import Collection from "./pages/collection/Collection";
import Campaigns from "./pages/campaigns/Campaign";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./redux/store";
import PrivateRoute from "./utils/PrivateRoute";
import NotFound from "./utils/NotFound";

import { createTheme, ThemeProvider } from "@mui/material";

import OfferManagement from "./pages/offers/OfferManagement";
import VoucherBatch from "./pages/voucher/VoucherBatch";
import { LOGOUT } from "./redux/actions/actionTypes";
import { loadUser } from "./redux/actions/auth.actions";
import { useEffect } from "react";
import setAuthToken from "./services/setAuthToken";
import PlatFormUser from "./pages/platform-report/PlatForm.user";
import PlatFormSummary from "./pages/platform-report/PlatForm.summary";
import LayoutNew from "./new-layout/layout";
import { Toaster } from "react-hot-toast";
import appRoutes from "./Routes/AllRoutes";

const theme = createTheme({
	palette: {
		primary: {
			main: "rgba(51, 102, 255, 0.3)",
		},
		secondary: {
			main: "rgba(51, 102, 255, 0.3)",
		},
	},
});

const App = () => {
	const {loading} = useSelector((state) => state?.authReducer);

	//const dispatch=useDispatch();
	useEffect(() => {
		// check for token in LS when app first runs
		if (localStorage.accessToken) {
			// if there is a token set axios headers for all requests
			setAuthToken(localStorage.accessToken);
		}

		// try to fetch a user, if no token or invalid token we
		// will get a 401 response from our API
		store.dispatch(loadUser());

		//log user out from all tabs if they log out in one tab
		window.addEventListener("storage", () => {
			if (!localStorage.accessToken) store.dispatch({ type: LOGOUT });
		});
	}, []);

	if(loading) return <></>

	return (
		// <ThemeProvider theme={theme}>
		<>
			<Router>
				<Routes>
					<Route path='/login' element={<Login />} />
					<Route path="/" element={<LayoutNew />}>
						{appRoutes.map((route, index) => (
							<Route key={index} path={route.path} element={route.element} />
						))}
					</Route>
					<Route path='/*' element={<NotFound />} />
				</Routes>
			</Router>
			<Toaster
				position="top-center"
				reverseOrder={false}
				toastOptions={{
					duration: 3000,
				}}
			/>
		</>
		// </ThemeProvider>
	);
};

export default App;
